import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'colors' })

export class ColorsPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) { }

	transform(item: any): SafeHtml {
		let html = '';

		for (const prop in item) {

			// regex matches #aabbff and aabbff, and #eee, not eee aabbgg or #aabbgg
			if (
				typeof item[prop] === 'string' && !['skin_widgetColor', 'skin_backgroundColor'].includes(prop)
				&& (item[prop].match(/^(#?)([0-9a-fA-F]{2}){3}$/) || item[prop].match(/^#([0-9a-fA-F]{2}){3}$/))
			) {
				html += '<span class="colorfilter" style="background-color: ' +
					(item[prop].indexOf('#') === -1 ? '#' : '') + item[prop] + '" title="' + item[prop] + '"></span>';
			}
		}

		return this.sanitizer.bypassSecurityTrustHtml(html);
	}
}
